import Cookies from 'js-cookie'
import { config } from 'app/params'

const tokenKey = 'token'

export const getToken = () => {
  var token = Cookies.get(tokenKey)
  return token
}

export const setToken = (token: string, duration?: number) => {
  if (token == null || token === '') console.error('Unable to set Token: token doesn\'t exist')

  let expiryDays = config.auth.token.expiryDays
  if (duration != null) expiryDays = duration * 60 * 24

  Cookies.set(tokenKey, token, {
    expires: expiryDays,
    // secure: true,
    sameSite: 'strict'
  })

  // console.log('User token set, expires in ' + expiryDays + ' days')
}

export const deleteToken = () => {
  Cookies.remove(tokenKey)
  // console.log('User token deleted')
}

export const tokenIsAvailable = () => {
  var token = getToken()
  return token != null
}